import {TranslationKeys} from '@colonist/i18n'
import {VictoryPointTypes} from '@colonist/game-base-types'

export abstract class BaseVictoryPointData {
    abstract victoryPointType: VictoryPointTypes
    abstract value: number
    abstract private: boolean
    abstract endGameToolTipKey: TranslationKeys

    getNewInstanceOfData(): BaseVictoryPointData {
        /* eslint-disable @typescript-eslint/prefer-function-type */
        const newInstance = new (this.constructor as {new (): BaseVictoryPointData})()
        return newInstance
    }
}
